import { waitForCallBackOrExpire } from '../utils/methods';

export const ENABLED = true;
export const DISABLED = false;

export const ToolBarButtons: Record<string, any> = {
  POINT: 'Draw a point',
  POLYLINE: 'Draw a polyline',
  POLYGON: 'Draw a polygon',
  // RECTANGLE: 'Draw a rectangle', //currently not implemented
  // CIRCLE: 'Draw a circle', //currently not implemented
};

const changeButtonState = (actionValue: string, enable: boolean): Promise<void> => new Promise((resolve, reject) => {
  waitForCallBackOrExpire(() => document.querySelector(`calcite-action[title="${actionValue}"]`), 500)
    .then(() => {
      const elements = document.querySelectorAll(`calcite-action[title="${actionValue}"]`);
      const element = elements[elements?.length - 1];
      if (element) {
        if (enable) {
          element.removeAttribute('disabled');
        } else {
          element.setAttribute('disabled', 'true');
        }
      }
      resolve();
    })
    .catch((e) => {
      console.warn(`Sketch is not ready. Element with title="${actionValue}" not found.`, e);
      reject(new Error(e));
    });
});

// This can handle ToolBarButtons object for all buttons or single buttons
// enables a single tool: setGraphicToolState(ToolBarButtons.POLYLINE, ENABLED);
// enables all tool buttons: setGraphicToolState(ToolBarButtons, ENABLED)
export const setGraphicToolState = async (
  toolBarButtons: Record<string, any> | string,
  enable: boolean,
) => {
  try {
    if (typeof toolBarButtons === 'string') {
      await changeButtonState(toolBarButtons, enable);
    } else {
      const promises = Object.values(toolBarButtons).map((actionValue) => changeButtonState(actionValue, enable));
      await Promise.all(promises);
    }
  } catch (error) {
    console.warn('Event while changing button state', error);
  }
};
